import React from 'react';
import { ProductItem, ProductCategory } from '../../../../types/summary';
import ProductCard from './ProductCard';

interface ProductListProps {
  list: (ProductItem | ProductCategory)[];
}

const ProductList: React.FC<ProductListProps> = ({ list }) =>
  list?.length ? (
    <>
      {list.map((item, key) => {
        if ('data' in item && Array.isArray(item.data)) {
          return <ProductList key={`product-${key}`} list={item.data} />;
        }
        return <ProductCard key={`product-${key}`} item={item as ProductItem} />;
      })}
    </>
  ) : null;

export default ProductList;
